import { render, staticRenderFns } from "./CarreraPolicialComponent.vue?vue&type=template&id=5a331fc6"
import script from "./CarreraPolicialComponent.vue?vue&type=script&lang=js"
export * from "./CarreraPolicialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports